import Image from "next/image";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import BeforeAfterCategoryTabs from "./BeforeAfterCategoryTabs";
import { BeforeAfterCategoryData } from "./types";

const BeforeAfterCategories = ({
  categories,
  beforeLabel,
  afterLabel
}: {
  categories: BeforeAfterCategoryData[];
  beforeLabel?: string;
  afterLabel?: string;
}) => {
  return (
    <TabGroup className="beforeafter-categories-container w-full" defaultValue={categories[0].title}>
      <TabList className="mx-auto mb-4 flex h-fit flex-nowrap justify-start gap-3 overflow-x-auto overflow-y-hidden scrollbar-hide md:justify-center">
        {categories.map((category) => (
          <Tab
            key={category.title}
            value={category.title}
            className="rounded-full bg-white py-2  text-lg font-normal data-[state=active]:bg-gold data-[state=active]:text-primary-700"
          >
            {category.icon &&
              (typeof category.icon === "string" ? (
                <span className="relative mr-2 h-7 w-7">
                  <Image src={category.icon} alt={`${category.title} icon`} fill />
                </span>
              ) : (
                category.icon
              ))}
            {category.title}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {categories.map((category) => (
          <TabPanel key={category.title} className="mt-20 max-md:mt-10">
            <BeforeAfterCategoryTabs tabs={category.tabs} beforeLabel={beforeLabel} afterLabel={afterLabel} />
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
};

export default BeforeAfterCategories;
